import { Module, ModuleTree } from "vuex";
import { State } from "./state";
import Mutations from "./mutations";
import Getters from "./getters";
import Actions from "./actions";
import List from "@/store/Abstract/List";
import { ICalendarTime } from "@/interfaces/ICalendarTime";
import LocalFilter from "@/store/Abstract/LocalFilter";

export default class Calendar implements Module<State, any> {
  namespaced = true;
  state: State;
  mutations = Mutations;
  getters = Getters;
  actions = Actions;
  modules: ModuleTree<any>;

  constructor() {
    this.state = new State();
    this.modules = {
      nightTimes: new List<ICalendarTime>(),
      localFilter: new LocalFilter(),
    };
  }
}
